import { CollabsibleContainer, lockBody, unlockBody } from "@plugins";
import { elementScrollIntoView } from "seamless-scroll-polyfill";
import noUiSlider from "nouislider";
import wNumb from "wnumb";

const filter = document.querySelector(".js-filter");
const sliderRange = document.querySelectorAll(".filter-range-slider");
const filterCategoriesContainer = document.querySelector(".js-categories-scrolling-init");

if (filter) {
    const collabsibleContaieners = filter.querySelectorAll(".js-filter-collabsible-container");
    const toggler = filter.querySelector(".js-filter-mob-toggler");

    if (toggler && window.mobileMedia) {
        const mobCollapsibleContainer = filter.querySelector(".js-filter-form");

        if (mobCollapsibleContainer) {
            toggler.addEventListener("click", () => {
                mobCollapsibleContainer.classList.toggle("active");
                toggler.classList.toggle("active");
            });
        }
    }

    for (let collabsibleContaiener of collabsibleContaieners) {
        collabsibleContaiener = new CollabsibleContainer(collabsibleContaiener, {
            buttonClasses: "filter__more js-filter-more",
            collapsibleItemsClass: "js-filter-collabsible-item",
            limiter: 5,
        });
    }
}

class FilterPopup {
    constructor(element, options) {
        Object.assign(this);

        // const filter = this;

        this._setDefaults(options);

        this.element = element;
        this.openFilterBtn = document.querySelector(".js-filter-modal-trigger");
        this.closeFilter = document.querySelectorAll(".js-filter-close");

        // this.isOpen = new Proxy(this.isOpen, {
        //     set(target, name, val) {
        //         target[name] = val;

        //         if (val) {
        //             setTimeout(() => {
        //                 document.addEventListener("click", (e) => {
        //                     if (
        //                         e.target !== filter.openFilterBtn &&
        //                         !e.target.closest(".filter__popup")
        //                     ) {
        //                         filter.close(filter.element);
        //                     }
        //                 });
        //             }, "100");
        //         }

        //         return true;
        //     },
        // });

        if (this.openFilterBtn) {
            this.openFilterBtn.addEventListener("click", () => {
                this.open(this.element);
            });
        }

        if (this.closeFilter.length > 0) {
            this.closeFilter.forEach((el) => {
                el.addEventListener("click", () => {
                    this.close(this.element);
                });
            });
        }
    }

    _setDefaults(options) {
        const defaults = {
            isOpen: {
                state: false,
            },
        };
        Object.assign(this, defaults, options);
    }

    open(element) {
        if (!this.isOpen.state) {
            this.isOpen.state = true;
            element.classList.add("opened");
            lockBody(this.element, { reserveScrollBarGap: true });
            // globalThis.ret.setLabelsWrapGridTemplate();
        }
    }

    close(element) {
        this.isOpen.state = false;
        element.classList.remove("opened");
        unlockBody();
    }
}

function initFilterModal() {
    if (filter) {
        new FilterPopup(filter);
    }
}

function initScrollingElements() {
    if (filterCategoriesContainer) {
        const filterCategoriesItems = filterCategoriesContainer.querySelectorAll(
            ".filter__categories-item",
        );

        if (filterCategoriesItems.length > 0) {
            filterCategoriesItems.forEach((item) => {
                item.addEventListener("click", () => {
                    const filterBlocks = document.querySelectorAll(".filter__form-block");

                    if (filterBlocks.length > 0) {
                        filterBlocks.forEach((block) => {
                            if (block.dataset.id === item.id) {
                                elementScrollIntoView(block, {
                                    behavior: "smooth",
                                    block: "start",
                                });
                            }
                        });
                    }
                });
            });
        }
    }
}

function initSliderRange() {
    for (let i = 0; i < sliderRange.length; i++) {
        const sliderRangeInner = sliderRange[i].closest(".filter-block");
        const marginMin = sliderRangeInner.querySelector(".min-price");
        const MinAttr = +sliderRange[i].getAttribute("data-min-price");
        const MinAttrUser = +sliderRange[i].getAttribute("data-min-price-user");
        const MaxAttr = +sliderRange[i].getAttribute("data-max-price");
        const MaxAttrUser = +sliderRange[i].getAttribute("data-max-price-user");
        const dataStep = +sliderRange[i].getAttribute("data-step");
        const marginMax = sliderRangeInner.querySelector(".max-price");

        noUiSlider.create(sliderRange[i], {
            start: [MinAttrUser, MaxAttrUser],
            behaviour: "drag",
            connect: true,
            step: dataStep,
            format: wNumb({
                decimals: 0,
            }),
            range: {
                min: MinAttr,
                max: MaxAttr,
            },
        });

        sliderRange[i].noUiSlider.on("update", (values, handle) => {
            if (handle) {
                marginMax.value = values[handle];
            } else {
                marginMin.value = values[handle];
            }
        });
        marginMin.addEventListener("change", (e) => {
            sliderRange[i].noUiSlider.set([e.target.value, null]);
        });
        marginMax.addEventListener("change", (e) => {
            sliderRange[i].noUiSlider.set([null, e.target.value]);
        });
    }
}

window.addEventListener("load", initFilterModal(), initSliderRange(), initScrollingElements());
